import { render, staticRenderFns } from "./CourseBoardsShow.vue?vue&type=template&id=7d199e36&scoped=true&"
import script from "./CourseBoardsShow.vue?vue&type=script&lang=ts&"
export * from "./CourseBoardsShow.vue?vue&type=script&lang=ts&"
import style0 from "./CourseBoardsShow.vue?vue&type=style&index=0&id=7d199e36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d199e36",
  null
  
)

export default component.exports